module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClass,
    on: {
      "click": function($event) {
        return _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "p-hidden-accessible"
  }, [_c('input', {
    ref: "input",
    attrs: {
      "type": "checkbox",
      "id": _vm.inputId,
      "name": _vm.name,
      "disabled": _vm.disabled,
      "role": "switch",
      "aria-checked": _vm.value,
      "aria-labelledby": _vm.ariaLabelledBy
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "focus": function($event) {
        return _vm.onFocus($event)
      },
      "blur": function($event) {
        return _vm.onBlur($event)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onClick($event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "p-inputswitch-slider"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00eb8a6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/inputswitch/InputSwitch.vue
// module id = 2002
// module chunks = 0